import styled from "styled-components";

export const SelectTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
